<template>
  <div class="inline-block">
    <vs-button
      v-if="modo === 'cadastro'"
      color="success"
      icon="add"
      icon-pack="material-icons"
      size="small"
      type="relief"
      @click="abrir"
    >Nova Exceção
    </vs-button>
    <vs-button
      v-else
      color="primary"
      icon="edit"
      icon-pack="material-icons"
      radius
      size="small"
      type="flat"
      @click="abrir"
    ></vs-button>

    <vs-popup
      :active.sync="modalAtivo"
      :title="modo === 'cadastro' ? 'Nova Exceção de Alíquota' : 'Editar Exceção de Alíquota'"
      @close="fechar"
    >
      <div id="formExcecaoFiscal">
        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              v-model="form.cMun"
              v-validate="'required|numeric|min:7|max:7'"
              :disabled="modo === 'edicao'"
              class="inputx w-full"
              label="Código do Município (IBGE)"
              name="cMun"
              placeholder="Ex.: 1302603"
            />
            <span v-show="errors.has('cMun')" class="text-danger text-sm">{{
              $validators.empty
            }}</span>
          </vs-col>
        </vs-row>

        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              v-model="form.nome"
              class="inputx w-full"
              label="Município (opcional, apenas exibição)"
              name="nome"
              placeholder="Ex.: Manaus"
            />
          </vs-col>
        </vs-row>

        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              v-model="form.cst"
              v-validate="'required'"
              class="inputx w-full"
              label="CST (IBS/CBS)"
              name="cst"
              placeholder="Ex.: 01"
            />
            <span v-show="errors.has('cst')" class="text-danger text-sm">{{
              $validators.empty
            }}</span>
          </vs-col>
        </vs-row>

        <vs-row vs-justify="flex-end" vs-type="flex" vs-w="12">
          <vs-button class="mr-3" color="dark" size="small" type="flat" @click="fechar"
          >Cancelar
          </vs-button>
          <vs-button
            v-if="modo === 'edicao'"
            class="mr-3"
            color="danger"
            size="small"
            type="border"
            @click="excluir"
          >Excluir
          </vs-button>
          <vs-button color="success" size="small" type="relief" @click="salvar"
          >{{ modo === "cadastro" ? "Adicionar" : "Atualizar" }}
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  name: "ModalExcecaoFiscal",
  props: {
    modo: {
      type: String,
      default: "cadastro"
    },
    excecao: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      modalAtivo: false,
      form: {
        cMun: "",
        nome: "",
        cst: ""
      }
    };
  },
  methods: {
    async abrir () {
      this.montarFormulario();
      this.$validator.reset();
      this.modalAtivo = true;
    },
    montarFormulario () {
      if (this.modo === "edicao") {
        this.form = {
          cMun: this.excecao.cMun,
          nome: this.excecao.nome,
          cst: this.excecao.cst
        };
      } else {
        this.form = { cMun: "", nome: "", cst: "" };
      }
    },
    async salvar () {
      const valido = await this.$validator.validateAll();
      if (!valido) {
        this.$vs.notify(this.$notify.Empty);
        return;
      }
      this.$emit("salvar", { ...this.form });
      this.modalAtivo = false;
    },
    excluir () {
      this.$emit("excluir", this.form.cMun);
      this.modalAtivo = false;
    },
    fechar () {
      this.modalAtivo = false;
      this.montarFormulario();
    }
  },
  components: components
};
</script>

<style scoped>
.inline-block {
  display: inline-block;
}
</style>
